import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";
import { getIntegrationBrandLogoUrl } from "./utils/integrationBrandLogos.js";

function IntegrationLogo({ id, name }) {
  const [failed, setFailed] = useState(false);
  const url = getIntegrationBrandLogoUrl(id);
  const initials = (name || "?")
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  if (failed || !url) {
    return (
      <span className="integrations-card-fallback" aria-hidden>
        {initials}
      </span>
    );
  }
  return (
    <img
      src={url}
      alt=""
      className="integrations-card-logo-img"
      width={48}
      height={48}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}

export default function Integrations() {
  const { t } = useTranslation();

  const integrations = [
    { id: "github", name: "GitHub", description: t("integration_github") },
    { id: "slack", name: "Slack", description: t("integration_slack") },
    { id: "google-drive", name: "Google Drive", description: t("integration_drive") },
    { id: "figma", name: "Figma", description: t("integration_figma") },
    { id: "notion", name: "Notion", description: t("integration_notion") },
    { id: "jira", name: "Jira", description: t("integration_jira") },
    { id: "vscode", name: "VS Code", description: t("integration_vscode") },
    { id: "discord", name: "Discord", description: t("integration_discord") },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content integrations-page integrations-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Solutions</p>
          <h1>{t('integrations_title')}</h1>
          <p className="page-lead" style={{ marginBottom: 0 }}>{t('integrations_subtitle')}</p>
        </header>

        <div className="integrations-grid">
          {integrations.map((integration) => (
            <div key={integration.id} className="marketing-section-card integrations-card">
              <div className="integrations-card-logo" aria-hidden>
                <IntegrationLogo id={integration.id} name={integration.name} />
              </div>
              <h3 className="marketing-section-title">{integration.name}</h3>
              <p className="marketing-section-text integrations-card-desc">{integration.description}</p>
            </div>
          ))}
        </div>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">{t('api_access')}</h2>
          <p className="marketing-section-text mb-4">{t('api_access_desc')}</p>
          <Link to="/docs" className="marketing-cta">{t('view_api_docs')}</Link>
        </section>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">{t('request_integration')}</h2>
          <p className="marketing-section-text mb-4">{t('request_integration_desc')}</p>
          <Link to="/Contact" className="marketing-cta marketing-cta--secondary">{t('submit_request')}</Link>
        </section>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
